<span [class]="classes">{{ type | humancase }}</span>
